import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { EventsAwardsLandingPageContext } from "@events-awards/utils/types";
import { MetaDescriptorProps } from "@features/seo/utils/types";
import { Route } from "@route-types/Section/layouts/EventsAwards/SCA/+types/EventsAwardsSCAPage";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { createMetaTags } from "@sphtech/web2-seo-schema";
import { HttpStatusCode } from "axios";

import { fetchEventsAwardsSCAPageData } from "./EventsAwardsSCAPage.server";
import EventsAwardsSCAPageContent from "./EventsAwardsSCAPageContent";

/** This is the main entry point component for /events-awards/singapore-corporate-awards route. */
const EventsAwardsSCAPage = (): React.ReactElement => {
  const context = useLoaderData<EventsAwardsLandingPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <EventsAwardsSCAPageContent
      {...context.payload.data}
      gaProps={context.payload.gaProps}
    />
  );
};

export default EventsAwardsSCAPage;

export const loader = async () => await fetchEventsAwardsSCAPageData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaDescriptorProps[] => {
  const context = loaderData as EventsAwardsLandingPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return createMetaTags(data.metaTags);
};
